export default {"src":"/_next/static/image/public/images/ic_pay_cod.c5bf3bc86d90c0359eda5e469d239a74.svg","height":9,"width":25};